import { Collapse } from "antd";
import type { FC } from "react";
import { useTranslation } from "react-i18next";

import type { AppConfigsFormConfiguration, AppConfigsTab } from "src/app/features/ApplicationConfigurations/types/AppConfigsTypes";
import type { AntCustomFormField, CommonFieldAttributes } from "../../../../../components/Form/types/types";
import { deepClone } from "../../../../../core/utils/utilFunctions";
import { ApplicationConfigurationsTab } from "./ApplicationConfigurationsTab";

export interface ApplicationConfigurationsFormProps extends AntCustomFormField<string>, CommonFieldAttributes {
    appConfigsFormData: AppConfigsFormConfiguration;
    onChangeCallback: Function;
}

export const ApplicationConfigurationsForm: FC<ApplicationConfigurationsFormProps> = ({ appConfigsFormData, onChangeCallback }) => {
    const { Panel } = Collapse;
    const { t } = useTranslation();

    const onChangeCallbackTabs = (tabData: AppConfigsTab) => {
        if (!appConfigsFormData) return;
        const { header } = tabData;
        // insert onChange value into collapseModel value appConFigsData, using tab name
        if (appConfigsFormData?.configTabs) {
            const newAppConfigsData = deepClone(appConfigsFormData);

            // find index of tab to replace with onChange data
            const index = newAppConfigsData.configTabs.findIndex((tab: AppConfigsTab) => tab.header === header);

            if (index > -1) {
                newAppConfigsData.configTabs[index] = tabData;
            }

            if (onChangeCallback) {
                onChangeCallback(newAppConfigsData);
            }
        }
    };

    const renderPanels = (data: AppConfigsTab[]) => {
        return data?.map((dataItem) => {
            const fields = dataItem.configFields;
            return (
                <Collapse key={`${dataItem.key}-Collapse`}>
                    <Panel header={t(dataItem.header)} key={`${dataItem.key}-Panel`}>
                        {fields && <ApplicationConfigurationsTab appConfigsTab={dataItem} onChangeCallback={onChangeCallbackTabs} />}
                    </Panel>
                </Collapse>
            );
        });
    };

    return <Collapse>{renderPanels(appConfigsFormData.configTabs || [])}</Collapse>;
};
